import {Entity} from 'app/core/main.entity';
import {FormElementValidationTypes} from '../enums';
import 'reflect-metadata';

export class FormElementValidation extends Entity {
  type: FormElementValidationTypes;
  text: string;
  pattern?: string;
  relation?: string;

  constructor(options: Partial<FormElementValidation> = null) {
    super();

    Object.assign(this, options);
  }
}
